import script from "./Activity_Test0522.vue?vue&type=script&setup=true&lang=js"
export * from "./Activity_Test0522.vue?vue&type=script&setup=true&lang=js"

import "./Activity_Test0522.vue?vue&type=style&index=0&id=7d07b0dc&lang=less&scoped=true"
import "./Activity_Test0522.vue?vue&type=style&index=1&id=7d07b0dc&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d07b0dc"]])

export default __exports__